import React from "react";
import { RatingReviewDetailFormInsertView } from "./view";
import { styles } from "./styles";

export const RatingReviewDetailFormInsert = props => (
  <RatingReviewDetailFormInsertView {...props} styles={styles} />
);
